<template>
  <div class="tab-list">
    <p>
      <router-link :class="{active: nav === 'policy'}" :to="{name: 'Policy'}">
        看政策
      </router-link>
    </p>
    <p>
      <router-link :class="{active: nav === 'project' || nav === 'project-find'}" :to="{name: 'ProjectFind'}">
        查项目
      </router-link>
    </p>
   <!-- <p>
      <router-link :class="{active: nav === 'financial'}" :to="{name: 'Financial'}">
        金融
      </router-link>
    </p> -->
    <p>
      <router-link :class="{active: nav === 'specialist'}" :to="{name: 'VSpecialist'}">
        聘专家
      </router-link>
    </p>
    <!-- <p>
      <router-link :class="{active: nav === 'organization'}" :to="{name: 'VOrganization'}">
        机构
      </router-link>
    </p>
    <p>
      <router-link :class="{active: nav === 'product'}" :to="{name: 'Product'}">
        产品
      </router-link>
    </p>
    <p>
      <router-link :class="{active: nav === 'service'}" :to="{name: 'Service'}">
        服务
      </router-link>
    </p> -->
    <p>
      <router-link :class="{active: nav === 'standard'}" :to="{name: 'Standard'}">
        创标准
      </router-link>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'ViewTabList',
    props: {
      msg: String,
    },
    data() {
      return {
        nav: 'policy'
      }
    },
    watch: {
      $route(to, from) {
        this.matchNav(to);
      }
    },
    mounted() {
      this.matchNav(this.$route);
    },
    methods: {
      matchNav(route) {
        const path = route.path
        this.nav = path.substr(path.lastIndexOf('/') + 1)
      }
    }
  };
</script>

<style scoped>
  .tab-list {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-bottom: 2px solid #0091FF;
  }

  .tab-list a {
    display: block;
    float: left;
    color: #424141;
    font-size: 16px;
    width: 96px;
    text-align: center;
  }

  .tab-list a.active,
  .tab-list a:hover {
    background: #267FF2;
    color: #fff;
  }

  @media screen and (max-width: 850px) {
    .tab-list {
      line-height: .72rem;
      height: .72rem;
    }

    .tab-list a {
      font-size: .26rem;
      width: 1.4rem;
    }

    .tab-list {
      display: flex;
      -webkit-display: flex;
      overflow-x: scroll;
      overflow-y: hidden;
    }

    .tab-list p {
      display: flex;
    }
  }
</style>
